export const moviesData = [
  {
    id: 1,
    title: "The Shawshank Redemption",
    year: 1994,
    genre: "Drama",
    rating: 9.3,
  },
  {
    id: 2,
    title: "The Dead Poet's Society",
    year: 1989,
    genre: "Drama",
    rating: 8.1,
  },
  { id: 3, title: "The Goonies", year: 1985, genre: "Adventure", rating: 7.8 },
  {
    id: 4,
    title: "The Perks of Being a Wallflower",
    year: 2012,
    genre: "Drama",
    rating: 8.0,
  },
  {
    id: 5,
    title: "The Breakfast Club",
    year: 1985,
    genre: "Comedy",
    rating: 8.1,
  },
  {
    id: 6,
    title: "The Lord of the Rings: The Fellowship of the Ring",
    year: 2001,
    genre: "Fantasy",
    rating: 8.8,
  },
  { id: 7, title: "Gifted", year: 2017, genre: "Drama", rating: 7.2 },
  {
    id: 8,
    title: "The Lion King",
    year: 1994,
    genre: "Animation",
    rating: 8.5,
  },
  { id: 9, title: "The Avengers", year: 2012, genre: "Action", rating: 8.0 },
  {
    id: 10,
    title: "The Dark Knight",
    year: 2008,
    genre: "Action",
    rating: 9.0,
  },
  {
    id: 11,
    title: "The fault in our stars",
    year: 2014,
    genre: "Romance",
    rating: 7.7,
  },
  { id: 12, title: "La La Land", year: 2016, genre: "Musical", rating: 8.2 },
  { id: 13, title: "The Matrix", year: 1999, genre: "Sci-Fi", rating: 8.7 },
  {
    id: 14,
    title: "Shutter Island",
    year: 2010,
    genre: "Thriller",
    rating: 7.8,
  },
  { id: 15, title: "Tomorrowland", year: 2015, genre: "Sci-Fi", rating: 6.5 },
  { id: 16, title: "Lucy", year: 2014, genre: "Action", rating: 6.4 },
  { id: 17, title: "Predistination", year: 2014, genre: "Sci-Fi", rating: 7.5 },
  { id: 18, title: "Interstellar", year: 2014, genre: "Sci-Fi", rating: 8.6 },
  { id: 19, title: "Inception", year: 2010, genre: "Sci-Fi", rating: 8.8 },
  { id: 20, title: "The Notebook", year: 2004, genre: "Romance", rating: 7.8 },
];
